/**
 * Normalizes and validates an https URL, rejecting any other protocol
 * (including protocol-relative or javascript: values). Shared by fields
 * that accept editor-supplied external links (virtual tours, booking
 * destinations, legacy WordPress references).
 */
export function normalizeHttpsUrl(value: string | null | undefined): string | null {
  if (!value?.trim()) {
    return null
  }

  try {
    const url = new URL(value.trim())
    if (url.protocol !== 'https:') {
      return null
    }

    return url.toString()
  } catch {
    return null
  }
}
